import { createSelector } from 'reselect';

export const customersSelector = createSelector(
  (state) => state && state.customer && state.customer.customers,
  (customersSelector) => customersSelector
);
export const raffleCustomersSelector = createSelector(
  (state) => state && state.customer && state.customer.raffleCustomers,
  (raffleCustomersSelector) => raffleCustomersSelector
);
export const pointWatchingSelector = createSelector(
  (state) => state && state.customer && state.customer.pointsWatching,
  (raffleCustomersSelector) => raffleCustomersSelector
);
export const pointWatchingByDateSelector = createSelector(
  (state) => state && state.customer && state.customer.pointWatchingByDate,
  (byDate) => byDate
);
export const pointWatchingEmployeeDaysSelector = createSelector(
  (state) =>
    state && state.customer && state.customer.pointWatchingEmployeeDays,
  (days) => days
);
export const pointWatchingDayEntriesSelector = createSelector(
  (state) => state && state.customer && state.customer.pointWatchingDayEntries,
  (entries) => entries
);
export const pointWatchingAlertsSelector = createSelector(
  (state) => state && state.customer && state.customer.pointWatchingAlerts,
  (alerts) => alerts
);
export const customerPointHistorySelector = createSelector(
  (state) => state && state.customer && state.customer.customerPointHistory,
  (customerPointHistorySelector) => customerPointHistorySelector
);
export const historicalCustomersSelector = createSelector(
  (state) => state && state.customer && state.customer.historicalCustomers,
  (historicalCustomersSelector) => historicalCustomersSelector
);
